import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import Header from'../Component/Header'
const WithdrawalsDismissals = () => { 
  useEffect(() => {
    document.title = ' Withdrawals and Dismissals - St. Josephs School Quadian Punjab';  
}, []); 
  return (
     <> 
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Academic</li>
                 <li>Withdrawals and Dismissals</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2>Withdrawals and Dismissals</h2>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12"> 
                      <ul className="list">
                      <li> No school leaving certificate will be issued without a written application from the parent/guardian after the payment of all dues to the school. </li> <li> Prior to the withdrawal of a student from the school in the middle of a term, a month's notice or payment of a month's fee is required. </li>
                      <li> As a rule students who are dismissed from the school will not be re-admitted. </li> 
                      <li> Irregular attendance, habitual idleness, disobedience, bad conduct, involvement in sexual harassment, sexual misconduct with the students of opposite or same gender, or sickness liable to be injurious to himself/herself or contagious to other students, etc. will justify the demand for withdrawal of a student from the school. Children of those parents who regularly make complaints and are not satisfied with the facilities provided by the school management will be given notice to withdraw their ward; if not withdrawn T.C. will be issued along with their progress report of the final exam. </li> 
                      <li> Readmission to this school will be banned for those who even if have  passed or are promoted academically, but have received "Notice of information" for in-disciplinary behavior in the school, for more than 3 times with a final warning and have not shown any remarkable improvement. They will be issued the T.C. along with their progress report. </li> 
                      <li> The Principal's decision shall be final in all cases of dismissal or withdrawal. </li> 
                      <li> A child who uses unfair means or receives or gives assistance in any form for cheating during examination & class- tests will be given zero in the subject and repetition of the same fault will result in dismissal of the student from the school. </li>
                      </ul>
                     </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default WithdrawalsDismissals

